export default __webpack_public_path__ + "static/media/02_C.71337815.png";